import React from "react";
import FactCheckIcon from '@mui/icons-material/FactCheck';

function Header() {
  return (
    <div className="drop-shadow-2xl border-b-2 border-lime-600 bg-gradient-to-r from-amber-700 via-red-500 to-yellow-500 p-3 text-xl font-bold h-[8vh] w-screen">
        <FactCheckIcon/>
      T0-d0-LIST
    </div>
  );
}

export default Header;
